<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>使用详情</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small">
          <el-form-item label="用户信息" prop="userName">
            <el-input v-model="searchForm.userName" placeholder="请输入用户信息"></el-input>
          </el-form-item>
          <el-form-item label="订单编号" prop="orderNo">
            <el-input v-model="searchForm.orderNo" placeholder="请输入订单编号"></el-input>
          </el-form-item>
          <el-form-item label="领取时间" prop="brandId">
            <el-date-picker v-model="getTime" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :clearable="true"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="使用时间" prop="brandId">
            <el-date-picker v-model="useTime" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :clearable="true"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="getList('search')">查询</el-button>
            <el-button type="primary" plain @click="getList('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div style="display: flex; align-items: center">
          <h3 style="margin-bottom: 0">列表数据</h3>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-upload2" @click="deriveDeliver()">导出</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-loading="loading" v-horizontal-scroll="'always'" :column="columns" :data="list" pagination
          :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo" :page-size="searchForm.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable
  },
  data() {
    return {
      getTime: [],
      useTime: [],
      dataList: {
        list: [
          { title: '优惠券管理', path: '', type: '0' },
          { title: '使用详情', path: '', type: '1' }
        ]
      },
      searchForm: {
        couponId: '',
        userName: '',
        orderNo: '',
        getTimeStart: '',
        getTimeEnd: '',
        useTimeEnd: '',
        useTimeStart: '',
        pageNo: 1,
        pageSize: 10
      },
      openTime: [],
      statuss: [
        {
          id: '0',
          name: '未上线'
        },
        {
          id: '1',
          name: '已上线'
        }
      ],
      list: [
        {
          name: '天兰',
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        }
      ],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '领取时间', prop: 'getTime', minWidth: '120' },
        {
          label: '用户信息', prop: 'userName', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <p style='text-align:left;'>{scope.row.userName}(ID：{scope.row.userId})</p>
                <p style='text-align:left;'>{scope.row.phone}</p>
              </div>
            )
          }
        },
        { label: '订单编号', prop: 'orderNo', minWidth: '120' },
        {
          label: '订单商品', prop: 'goodsInfo', minWidth: '120',
          renderHeader: (h, scope) => {
            return (
              <div style="text-align:left">订单商品</div>
            )
          },
          render: (h, scope) => {
            if (!scope.row.goodsInfoList) return
            return (
              <div>
                {
                  scope.row.goodsInfoList.map(item => {
                    return (
                      <p style="display:flex;flex-direction:column"><p style="text-align:left">{item.name}</p><p style="text-align:left">{item.sku + '*' + item.num}</p></p>
                    )
                  })
                }
              </div>
            )
          }
        },
        { label: '金额', prop: 'payPrice', minWidth: '120' },
        { label: '使用时间', prop: 'useTime', minWidth: '120' }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      categoryList: [],
      dictionaries: {},
      loading: false
    }
  },
  created() {
    //   this.getCategoryList()
    //   this.getDictionaries('platform_vip_level')
    this.getList()
  },
  mounted() {

  },
  methods: {
    //导出
    deriveDeliver() {
      this.axios.post('/users/exportCouponUseList', this.searchForm).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        }
      })
    },
    downloadlink(url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    onChangeCategory() {

    },
    onMultipleSelection(val) {
      this.selectionGoods = val
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.getList()
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.getList()
    },
    getList(type) {
      this.searchForm.couponId = this.$route.query.id
      if (type == 'reset') {
        this.searchForm = {}
        this.getTime = []
        this.useTime = []
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (this.getTime) {
        this.searchForm.getTimeStart = this.getTime[0]
        this.searchForm.getTimeEnd = this.getTime[1]
      } else {
        this.searchForm.getTimeStart = ''
        this.searchForm.getTimeEnd = ''
      }
      if (this.useTime) {
        this.searchForm.useTimeStart = this.useTime[0]
        this.searchForm.useTimeEnd = this.useTime[1]
      } else {
        this.searchForm.useTimeStart = ''
        this.searchForm.useTimeEnd = ''
      }
      this.axios.post('/users/getCouponUsePageList', this.searchForm).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            item.payPrice = Number(item.payPrice).toFixed(2)
          })
          res.data.list.forEach(item => {
            let arr = []
            item.goodsInfo.split(',').forEach(itm => {
              let obj = {
                name: itm.split('+')[0],
                sku: itm.split('+')[1],
                num: itm.split('+')[2]
              }
              console.log(obj)
              arr.push(obj)
            })
            Object.assign(item, { goodsInfoList: arr })
          })
          this.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false;
        }
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries['platform_vip_level'] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList() {
      const params = {}
      this.$api.categoryList(params).then((res) => {
        res.data.list.forEach(item => {
          if (item.children) {
            item.children.forEach(itm => {
              if (itm.children) {
                delete itm.children
              }
            })
          }
        })
        this.categoryList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    add(type, id) {
      if (type == 'look') {
        this.$router.push({
          name: 'lookPlatform',
          query: {
            type: type,
            id: id
          }
        })
      } else {
        this.$router.push({
          name: 'platListDetail',
          query: {
            type: type,
            id: id
          }
        })
      }

    },
    setting() {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    }
  }
}
</script>
<style  lang="scss">
.el-cascader-panel {
  .el-scrollbar:first-child {
    .el-checkbox {
      display: none;
    }
  }
}
</style>
<style scoped lang="scss">
::v-deep .el-cascader-panel:first-child .el-checkbox {
  display: none !important;
}

::v-deep .el-cascader-panel li[aria-haspopup] .el-checkbox {
  display: none !important;
}

.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}

.title {
  display: flex;
  justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
  
  